import React, { useState, useRef, useEffect } from 'react';
import Transition from '../../utils/Transition';
import FLAG_EN from 'assets/images/flag-uk.svg'
import FLAG_FR from 'assets/images/flag-fr.svg'
import { useTranslation } from 'react-i18next';

function LanguageSwitcher() {

    const { i18n ,t} = useTranslation();

    const [dropdownOpen, setDropdownOpen] = useState(false);

    const trigger = useRef(null);
    const dropdown = useRef(null);
    
    const handleOnclick = (e) => {
        i18n.changeLanguage(e.target.value);
        setDropdownOpen(false);
    }

    // close on click outside
    useEffect(() => {
        const clickHandler = ({ target }) => {
            if (!dropdownOpen || dropdown.current.contains(target) || trigger.current.contains(target)) return;
            setDropdownOpen(false);
        };
        document.addEventListener('click', clickHandler);
        return () => document.removeEventListener('click', clickHandler);
    });

    // close if the esc key is pressed
    useEffect(() => {
        const keyHandler = ({ keyCode }) => {
            if (!dropdownOpen || keyCode !== 27) return;
            setDropdownOpen(false);
        };
        document.addEventListener('keydown', keyHandler);
        return () => document.removeEventListener('keydown', keyHandler);
    });


    return (
        <div className="relative inline-flex ml-3">
            <button
                ref={trigger}
                className={`w-8 h-8 flex items-center justify-center border   transition duration-150 rounded-full ${dropdownOpen && 'bg-white'}`}
                aria-haspopup="true"
                onClick={() => setDropdownOpen(!dropdownOpen)}
                aria-expanded={dropdownOpen}
            >
                <span className="sr-only">{t('actions.languages')}</span>
                <span className=' text-xs  font-semibold uppercase'>
                    {i18n.language?.substring(0,2)}
                </span>
            </button>

            <Transition
                className="origin-top-right z-10 absolute top-full right-0 min-w-44 bg-white border border-gray-200 py-1.5 rounded shadow-lg overflow-hidden mt-1"
                show={dropdownOpen}
                enter="transition ease-out duration-200 transform"
                enterStart="opacity-0 -translate-y-2"
                enterEnd="opacity-100 translate-y-0"
                leave="transition ease-out duration-200"
                leaveStart="opacity-100"
                leaveEnd="opacity-0"
            >
                <div
                    role="menu"
                    ref={dropdown}
                    onFocus={() => setDropdownOpen(true)}
                    onBlur={() => setDropdownOpen(false)}
                >
                    <div className="text-xs font-semibold text-gray-400 uppercase pt-1.5 pb-2 px-4">{t('actions.languages')}</div>
                    <ul>
                        <li>
                            <button
                                className="font-medium text-sm text-gray-500 hover:text-gray-600 flex items-center py-1 px-3"
                                to="#0"
                                onClick={handleOnclick}
                                value="en"
                            >
                                <img src={FLAG_EN} alt="en" className='w-5 h-5 mr-2' />
                                {t('languages.en')}
                            </button>
                        </li>
                        <li>
                            <button
                                className="font-medium text-sm text-gray-500 hover:text-gray-600 flex items-center py-1 px-3"
                                to="#0"
                                onClick={handleOnclick}
                                value="fr"
                            >
                                <img src={FLAG_FR} alt="fr" className='w-5 h-5 mr-2' />
                                {t('languages.fr')}
                            </button>
               
                        </li>

                    </ul>
                </div>
            </Transition>
        </div>
    )
}

export default LanguageSwitcher;